module.exports = __webpack_public_path__ + "img/img-search01.5eee2011.jpg";